function timestampMs(value) {
  const parsed = Date.parse(value || "");
  return Number.isFinite(parsed) ? parsed : 0;
}

function compactTitle(value, fallback = "Casper run") {
  const text = String(value || "").replace(/\s+/g, " ").trim();
  if (!text) return fallback;
  return text.length > 86 ? `${text.slice(0, 83)}...` : text;
}

function sessionTimestamp(session) {
  return session?.latest_message_at || session?.updated_at || session?.created_at || null;
}

export function buildCasperHistoryItems({ sessions = [], workflowHistoryItem = null } = {}) {
  const items = [];

  if (workflowHistoryItem?.id) {
    items.push({
      ...workflowHistoryItem,
      id: `workflow:${workflowHistoryItem.id}`,
      kind: "workflow",
      sessionId: workflowHistoryItem.session_id || workflowHistoryItem.sessionId || null,
      title: compactTitle(workflowHistoryItem.title, "Casper workflow run"),
      updated_at: workflowHistoryItem.updated_at || workflowHistoryItem.created_at || null,
    });
  }

  sessions.forEach((session) => {
    const runs = Array.isArray(session?.runs) ? session.runs : [];
    if (runs.length > 0) {
      runs.forEach((run, index) => {
        const sessionId = run.session_id || session.id;
        if (!sessionId) return;
        items.push({
          ...run,
          kind: "run",
          id: `run:${run.id || `${sessionId}:${run.message_id || index}`}`,
          sessionId,
          session,
          title: compactTitle(run.title || run.prompt || session.title, "Casper run"),
          subtitle: run.subtitle || "Casper run",
          message_count: Number(run.message_count || 0),
          updated_at: run.updated_at || run.created_at || sessionTimestamp(session),
        });
      });
      return;
    }

    if (!session?.id) return;
    items.push({
      kind: "session",
      id: `session:${session.id}`,
      sessionId: session.id,
      session,
      title: compactTitle(session.title, "Casper thread"),
      subtitle: "Saved thread",
      message_count: Number(session.message_count || 0),
      updated_at: sessionTimestamp(session),
    });
  });

  return items.sort((left, right) => timestampMs(right.updated_at) - timestampMs(left.updated_at));
}

export function countCasperHistoryRuns(sessions = [], workflowHistoryItem = null) {
  return buildCasperHistoryItems({ sessions, workflowHistoryItem }).length;
}
